import React, { useCallback, useEffect, useState } from 'react';

import qs from 'querystring';

import { useSelector } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';

import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';

import { t } from '~/helpers';
import api from '~/services/api';
import { includes, isEmpty } from 'lodash';
import { Spinner } from '~/components';
import { toast } from 'react-toastify';

import { GPP, FRENTISTA, ADM } from '~/constants/perfil';

import { Container } from './styles';

function OperacaoAlinhamento() {
  const { profile } = useSelector((state) => state.user);

  const [isLoading, setIsLoading] = useState(false);
  const [allowRegister, setAllowRegister] = useState(false)




  //Variaveis dos arrays
  const [listaPostosVO, setListaPostosVO] = React.useState([]);
  const [listaTanqueVirtualVO, setListaTanqueVirtualVO] = React.useState([]);
  const [listaTanqueFisicoVO, setListaTanqueFisicoVO] = React.useState([]);

  //Dados para postos
  const [rowsPosto, setRowsPosto] = React.useState([]);
  const [rowsPostoTV, setRowsPostoTV] = React.useState([]);
  const [rowsPostoTF, setRowsPostoTF] = React.useState([]);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      buscaPostosHandler();
    }
    return function cleanup() {
      mounted = false;
    };
  }, []);



  //Busca Postos
  async function buscaPostosHandler() {
    setListaPostosVO([]);
    try {
      setIsLoading(true);

      let params = {};

      switch (profile.glousuariotipo) {
        case GPP:
        case FRENTISTA:
          params = {
            fieldlist: 'POCO_CODIGO,POCO_DESC_ABREV',
            wherefield: 'POCO_CODIGO',
            typewherefield: 'EQUALS',
            valuewherefield: profile.glousuariopostocodigo,
            orderfield: 'POCO_CODIGO',
            pagesize: 99999,
          };

          break;
        default:
          params = {
            fieldlist: 'POCO_CODIGO,POCO_DESC_ABREV',
            orderfield: 'POCO_CODIGO',
            pagesize: 99999,
          };
      }

      const response = await api.get('postoscomboios', {
        params: {
          ...params,
        },
      });

      await setIsLoading(false);
      if (!isEmpty(response.data) && !isEmpty(response.data.items)) {
        setListaPostosVO(response.data.items);
      } else {
        toast.error('Não foi possível fazer a consulta!');
        setListaPostosVO([]);
      }
    } catch (err) {
      setListaPostosVO([]);
      setIsLoading(false);
      toast.error(` ${err} `);
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      gradePostosHandler();
    }
    return function cleanup() {
      mounted = false;
    };
  }, [listaPostosVO]);

  function gradePostosHandler() {
    let newRowsPosto = [];
    if (listaPostosVO) {
      for (let i = 0; i < listaPostosVO.length; i++) {
        const codigoposto = listaPostosVO[i].poco_codigo;
        const descricao = listaPostosVO[i].poco_desc_abrev;
        const obj = createDataPosto(codigoposto, descricao);
        newRowsPosto = newRowsPosto.concat(rowsPosto, obj);
        setRowsPosto(newRowsPosto);
      }
    }
  }

  //Busca Postos tanque virtual
  async function buscaPostoTanqueVirtualHandler(codigoposto) {
    await setListaTanqueVirtualVO([]);
    try {
      setIsLoading(true);

      const params = {
        fieldlist: 'poco_codigo,tavi_codigo,tavi_nome,prod_descricao',
        wherefield: 'poco_codigo',
        typewherefield: 'EQUALS',
        valuewherefield: codigoposto,
        orderfield: 'tavi_codigo',
        pagesize: 99999,
      };

      const response = await api.get('tanquevirtual', {
        params: {
          ...params,
        },
      });



      await setIsLoading(false);
      if (!isEmpty(response.data) && !isEmpty(response.data.items)) {
        setListaTanqueVirtualVO(response.data.items);
      } else {
        toast.error('Não foi possível fazer a consulta!');
        setListaTanqueVirtualVO([]);
      }
    } catch (err) {
      setListaTanqueVirtualVO([]);
      setIsLoading(false);
      toast.error(` ${err} `);
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      gradePostosTVHandler();
    }
    return function cleanup() {
      mounted = false;
    };
  }, [listaTanqueVirtualVO]);

  function gradePostosTVHandler() {
    let newRowsPostoTV = [];
    if (listaTanqueVirtualVO) {
      for (let i = 0; i < listaTanqueVirtualVO.length; i++) {
        const codigoposto = listaTanqueVirtualVO[i].poco_codigo;
        const codigotv = listaTanqueVirtualVO[i].tavi_codigo;
        const descricao = listaTanqueVirtualVO[i].tavi_nome;
        const combustivel = listaTanqueVirtualVO[i].prod_descricao;
        const obj = createDataPostoTV(
          codigoposto,
          codigotv,
          descricao,
          combustivel
        );
        newRowsPostoTV = newRowsPostoTV.concat(rowsPostoTV, obj);
        setRowsPostoTV(newRowsPostoTV);
      }
    }
  }

  //Busca Postos tanque Fisico
  async function buscaPostoTanqueFisicoHandler(codigoposto, codigotv) {
    setListaTanqueFisicoVO([]);
    try {
      setIsLoading(true);

      let wherefield = [];
      wherefield.push('poco_codigo');
      wherefield.push('tavi_codigo');

      const params = {
        fieldlist:
          'poco_codigo,tavi_codigo,tafi_codigo,tafi_nome,tafi_alinhado_string',
        wherefield: wherefield,
        typewherefield: ['EQUALS', 'EQUALS'],
        valuewherefield: [String(codigoposto), String(codigotv)],
        orderfield: 'tafi_codigo',
        pagesize: 99999,
      };

      const response = await api.get('tanquesfisicos', {
        params,
        paramsSerializer: (param) => qs.stringify(param),
      });

      await setIsLoading(false);
      if (!isEmpty(response.data) && !isEmpty(response.data.items)) {
        setListaTanqueFisicoVO(response.data.items);
      } else {
        toast.error('Não foi possível fazer a consulta!');
        setListaTanqueFisicoVO([]);
      }
    } catch (err) {
      setListaTanqueFisicoVO([]);
      setIsLoading(false);
      toast.error(` ${err} `);
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      gradePostosTFHandler();
    }
    return function cleanup() {
      mounted = false;
    };
  }, [listaTanqueFisicoVO]);

  function gradePostosTFHandler() {
    let newRowsPostoTF = [];
    if (listaTanqueFisicoVO) {
      for (let i = 0; i < listaTanqueFisicoVO.length; i++) {
        const codigoposto = listaTanqueFisicoVO[i].poco_codigo;
        const codigotv = listaTanqueFisicoVO[i].tavi_codigo;
        const codigotf = listaTanqueFisicoVO[i].tafi_codigo;
        const descricao = listaTanqueFisicoVO[i].tafi_nome;
        const alinhado = listaTanqueFisicoVO[i].tafi_alinhado_string;
        const obj = createDataPostoTF(
          codigoposto,
          codigotv,
          codigotf,
          descricao,
          alinhado
        );
        newRowsPostoTF = newRowsPostoTF.concat(rowsPostoTF, obj);
        setRowsPostoTF(newRowsPostoTF);
      }
    }
  }

  function createDataPosto(codigoposto, descricao) {
    return { codigoposto, descricao };
  }

  function createDataPostoTV(codigoposto, codigotv, descricao, combustivel) {
    return { codigoposto, codigotv, descricao, combustivel };
  }

  function createDataPostoTF(
    codigoposto,
    codigotv,
    codigotf,
    descricao,
    alinhado
  ) {
    return { codigoposto, codigotv, codigotf, descricao, alinhado };
  }

  const [selectedPosto, setSelectedPosto] = useState({})

  useEffect(() => {
    if (!isEmpty(selectedPosto)) {
      handleRequestAuditoria(selectedPosto)
    }
  }, [selectedPosto])

  const handleRequestAuditoria = useCallback(async (posto) => {
    await api.post('alinhamento/gravaauditoriaacesso', {
      whereField: ["poco_codigo", "poco_descricao"],
      valueWhereField: [posto.codigoposto, posto.descricao],
      typeWhereField: ["EQUALS", "EQUALS"],
      orderField: "",
      ordination: ""
    })
  }, [])

  const handleClickPosto = (event, registro) => {
    setSelectedPosto(registro)
    let codigos = [registro.codigoposto]
    setRowsPostoTV([]);
    setRowsPostoTF([]);

    buscaPostoTanqueVirtualHandler(...codigos);
  };

  const handleClickTV = (event, registro) => {
    setRowsPostoTF([]);
    buscaPostoTanqueFisicoHandler(...registro);
    setAllowRegister(includes([GPP, FRENTISTA, ADM], profile.gloperfilid))
  };

  const handleClickTF = (event, registro) => {
    if (allowRegister) {
      handleClickListItem(registro);
    }

  };

  //Confirmar o registro
  //Dialog inicio */
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState('CLICK-OK');
  const [registro, setRegistro] = React.useState('');

  const handleClickListItem = (registro) => {
    setRegistro(registro);
    setOpen(true);
  };

  const handleClose = (newValue) => {
    setOpen(false);
    if (newValue) {
      setValue(newValue);
      if (newValue === 'CLICK-OK') {
        handleSubmit(registro);
      }
    }
  };

  function ConfirmationDialogRaw(props) {
    const { onClose, value: valueProp, open, ...other } = props;
    const [value, setValue] = React.useState(valueProp);
    const radioGroupRef = React.useRef(null);
    React.useEffect(() => {
      if (!open) {
        setValue(valueProp);
      }
    }, [valueProp, open]);
    const handleEntering = () => {
      if (radioGroupRef.current != null) {
        radioGroupRef.current.focus();
      }
    };
    const handleCancel = () => {
      onClose();
    };
    const handleOk = () => {
      onClose(value);
    };
    const handleChange = (event) => {
      setValue(event.target.value);
    };
    //const isSelected = (name) => selected.indexOf(name) !== -1;
    return (
      <div>
        <Dialog
          disableBackdropClick
          disableEscapeKeyDown
          maxWidth="xs"
          onEntering={handleEntering}
          aria-labelledby="confirmation-dialog-title"
          open={open}
          {...other}
        >
          <DialogTitle id="confirmation-dialog-title">Confirmar</DialogTitle>
          <DialogContent dividers>
            <span>
              Confirma{' '}
              {String(registro[3]) === 'Alinhado' ? ' retirar ' : ' incluir '} o
              Alinhamento para o Tanque Físico {registro[2]}. Deseja Salvar?
            </span>
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleCancel} color="primary">
              Cancel
            </Button>
            <Button onClick={handleOk} color="primary">
              Ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
  //***Dialog fim*/
  //********************** */

  async function handleSubmit(registro) {
    try {
      const poco_codigo = registro[0];
      const tavi_codigo = registro[1];
      const tafi_codigo = registro[2];

      const objSend = {
        poco_codigo,
        tavi_codigo,
        tafi_codigo,
      };

      if (String(registro[3]) === 'Alinhado') {
        await api.post('alinhamento/delete', objSend);
      } else {
        await api.post('alinhamento', objSend);
      }

      setRowsPostoTF([]);
      buscaPostoTanqueFisicoHandler(poco_codigo, tavi_codigo);
      toast.success(t('s.geral.sucessoalteracao'));
    } catch (err) {
      toast.error('Não foi possível fazer o alinhamento!');
    }
  }
  //*************************** */

  const useStyles = makeStyles({
    root: {
      width: '100%',
    },
    table: {
      minWidth: 345,
    },
    alinhado: {
      fontSize: '1.2rem',
      color: 'red',
    },
    container: {
      maxHeight: '65rem',
      ['@media (max-width: 1400px)']: {
        maxHeight: '30rem',
      },
    },
  });

  const classes = useStyles();

  return (
    <>
      <div>
        <ConfirmationDialogRaw
          id="ringtone-menu"
          keepMounted
          open={open}
          onClose={handleClose}
          value={value}
          registro={registro}
        />
      </div>

      <Container>
        {isLoading ? (
          <div style={{ zIndex: 999999 }}>
            <Spinner loading />
          </div>
        ) : (
          ''
        )}

        <div className="Container__info_01">
          <p>Selecione um Posto </p>
          <Paper className={classes.root}>
            <TableContainer className={classes.container}>
              <Table
                stickyHeader
                size="small"
                className={classes.table}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Código</TableCell>
                    <TableCell align="right">Descrição</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowsPosto.map((row) => (
                    <TableRow
                      key={row.codigoposto}
                      hover
                      onClick={(event) =>
                        handleClickPosto(event, row)
                      }
                    >
                      <TableCell component="th" scope="row">
                        {row.codigoposto}
                      </TableCell>
                      <TableCell align="right">{row.descricao}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </div>

        <div className="Container__info_01">
          <p>Selecione um Tanque Virtual </p>
          <Paper className={classes.root}>
            <TableContainer className={classes.container}>
              <Table
                stickyHeader
                size="small"
                className={classes.table}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Código</TableCell>
                    <TableCell align="right">Descrição</TableCell>
                    <TableCell align="right">Combustível</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowsPostoTV.map((row) => (
                    <TableRow
                      key={row.codigotv}
                      hover
                      onClick={(event) =>
                        handleClickTV(event, [row.codigoposto, row.codigotv])
                      }
                    >
                      <TableCell component="th" scope="row">
                        {row.codigotv}
                      </TableCell>
                      <TableCell align="right">{row.descricao}</TableCell>
                      <TableCell align="right">{row.combustivel}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </div>

        <div className="Container__info_01">
          <p>Selecione um Tanque Físico </p>
          <Paper className={classes.root}>
            <TableContainer className={classes.container}>
              <Table
                stickyHeader
                size="small"
                className={classes.table}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell>Código</TableCell>
                    <TableCell align="right">Descrição</TableCell>
                    <TableCell align="right">Alinhado</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rowsPostoTF.map((row) => (
                    <TableRow
                      key={row.codigotf}
                      hover
                      onClick={(event) =>
                        handleClickTF(event, [
                          row.codigoposto,
                          row.codigotv,
                          row.codigotf,
                          row.alinhado,
                        ])
                      }
                      selected={row.alinhado === 'Alinhado' ? true : false}
                      aria-checked={row.alinhado === 'Alinhado' ? true : false}
                    >
                      <TableCell component="th" scope="row">
                        {row.codigotf}
                      </TableCell>
                      <TableCell align="right">{row.descricao}</TableCell>
                      <TableCell align="right">
                        {row.alinhado === 'Alinhado' ? (
                          <Tooltip size="small" title="Retirar Alinhamento">
                            <IconButton size="small" aria-label="alinhar">
                              <div className={classes.alinhado}>Alinhado</div>
                              {allowRegister && (<DeleteIcon
                                fontSize="inherit"
                                size="small"
                                onClick={(event) =>
                                  handleClickTF(event, [
                                    row.codigoposto,
                                    row.codigotv,
                                    row.codigotf,
                                    row.alinhado,
                                  ])
                                }
                              />)}
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip size="small" title="Alinhar Tanque">
                            <IconButton size="small" aria-label="alinhar">
                              {/* <CheckCircleOutlineIcon size='small' onClick={(event) => handleClickTF(event, [row.codigoposto, row.codigotv, row.codigotf, row.alinhado])} /> */}
                            </IconButton>
                          </Tooltip>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </div>
      </Container>
    </>
  );
}

export default OperacaoAlinhamento;
